"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var react_1 = __importDefault(require("react"));

var identity_1 = require("../../identity");

var Spinner = function Spinner(_a) {
  var theme = _a.theme,
      backgroundImage = _a.backgroundImage;

  if (typeof window !== "undefined" && backgroundImage) {
    document.body.style.backgroundImage = "linear-gradient(to bottom, #0b3536 0%, rgba(125, 185, 232, 0)), url(" + backgroundImage + ")";
    document.body.style.backgroundAttachment = "fixed";
    document.body.style.backgroundSize = "cover";
  }

  var wrapper = "z-50 flex flex-col h-screen my-auto items-center bg-transparent";
  var style = "m-auto animate-spin duration-1000 " + (theme ? "" + theme.body.textColor : "text-gray-800");
  return react_1["default"].createElement("div", {
    className: wrapper
  }, react_1["default"].createElement(identity_1.Icon, {
    name: "spinner_of_dots",
    size: identity_1.IconSize.sm,
    className: style
  }));
};

exports.Spinner = Spinner;